import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../brand-colors';

function EmailMarketing() {
  const navigate = useNavigate();

  const sections = [
    {
      id: 'sequences',
      title: 'Email Sequences',
      icon: '📬',
      description: 'Automated email sequences for onboarding, nurturing, and sales.',
      path: '/command-center/campaign-hq/email/sequences',
    },
    {
      id: 'newsletters',
      title: 'Newsletters',
      icon: '📰',
      description: 'Regular newsletters to keep your audience engaged.',
      path: '/command-center/campaign-hq/email/newsletters',
      muted: true,
    },
    {
      id: 'one-off',
      title: 'One-Off Emails',
      icon: '📢',
      description: 'Announcements, promotions, and standalone broadcasts.',
      path: '/command-center/campaign-hq/email/one-off',
      muted: true,
    },
  ];

  const handleClick = (section) => {
    if (!section.muted) {
      navigate(section.path);
    }
  };

  return (
    <Container className="py-4">
      <div className="mb-4">
        <h1>Email Marketing</h1>
        <p className="text-muted">
          Create and manage email campaigns, sequences, and newsletters.
        </p>
      </div>

      <Row>
        {sections.map((section) => (
          <Col md={4} key={section.id} className="mb-4">
            <Card
              onClick={() => handleClick(section)}
              style={{
                cursor: section.muted ? 'not-allowed' : 'pointer',
                opacity: section.muted ? 0.5 : 1,
                border: `1px solid ${colors.goldMid}`,
                height: '100%',
                transition: 'transform 0.2s, box-shadow 0.2s',
              }}
              className={section.muted ? '' : 'hover-lift'}
              onMouseEnter={(e) => {
                if (!section.muted) {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = `0 4px 12px rgba(0,0,0,0.15)`;
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <Card.Body className="text-center py-4">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
                  {section.icon}
                </div>
                <Card.Title>{section.title}</Card.Title>
                <Card.Text className="text-muted small">
                  {section.description}
                </Card.Text>
                {section.muted && (
                  <span
                    className="badge"
                    style={{
                      backgroundColor: colors.greyMid,
                      color: colors.greyDarkest,
                    }}
                  >
                    Coming Soon
                  </span>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default EmailMarketing;
